import { render, staticRenderFns } from "./TrackList.vue?vue&type=template&id=bd84f4ae&scoped=true"
import script from "./TrackList.vue?vue&type=script&lang=js"
export * from "./TrackList.vue?vue&type=script&lang=js"
import style0 from "./TrackList.vue?vue&type=style&index=0&id=bd84f4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd84f4ae",
  null
  
)

export default component.exports